"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = require("styled-components");

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

/**
 * Flatten global styles
 * @return {array}
 */
var _default = function _default(theme) {
  if (!theme.hasOwnProperty("global")) {
    console.warn("No global styles present");
    return "";
  }

  return Object.keys(theme.global).reduce(function (acc, curr) {
    return [].concat(_toConsumableArray(acc), [(0, _styledComponents.css)(["", ";"], theme.global[curr])]);
  }, []);
};

exports["default"] = _default;